<template>
  <div class="invoice-index">
    <div class="title">
      <span>发票列表</span>
      <mu-button class="add-btn" color="purple" @click="addOpen = true">
        <mu-icon value="add" :size="20"></mu-icon>
        新增发票
      </mu-button>
    </div>
    <mu-form :model="form" label-width="80" class="form" :inline="true">
      <!-- <mu-form-item prop="search" label="搜索" label-position="left">
        <mu-text-field v-model="form.keyword" help-text="请输入客户名称"></mu-text-field>
      </mu-form-item> -->

      <mu-form-item prop="search" label="开始时间" label-position="left">
        <mu-date-input container="dialog" v-model="form.startTime"></mu-date-input>
      </mu-form-item>

      <mu-form-item prop="search" label="结束时间" label-position="left">
        <mu-date-input container="dialog" v-model="form.endTime"></mu-date-input>
      </mu-form-item>

      <mu-form-item>
        <mu-button color="primary" @click="getAll">搜索</mu-button>
      </mu-form-item>
    </mu-form>
    <div class="analysis">
      <mu-button fab color="indigo" large>
        {{ sum }}
      </mu-button>
    </div>
    <mu-paper :z-depth="1">
      <mu-data-table
        :columns="columns"
        :data="list"
        stripe
        class="table"
        :loading="loading"
      >
        <template slot-scope="scope">
          <td>
            <div>
              <p>{{ scope.row.customer.company }}</p>
              <p>{{ scope.row.customer.realName }}</p>
            </div>
          </td>
          <td>
            <div>
              <p>
                {{ scope.row.buyer }}
              </p>
              <p>
                {{ scope.row.buyerNum }}
              </p>
              <p>
                {{ moment(scope.row.publishDate).format('YYYY-MM-DD') }}
              </p>
            </div>
          </td>
          <td>
            <div>
              <p>金额：{{ scope.row.amount }}</p>
              <p>税金：{{ scope.row.tax }}</p>
              <p>合计：{{ scope.row.totalAmount }}</p>
            </div>
          </td>
          <td>
            <div>
              <p>代码：{{ scope.row.code }}</p>
              <p>号码：{{ scope.row.num }}</p>
            </div>
          </td>
          <td>
            <mu-button
              color="secondary"
              @click="viewImages(scope.row.pic)"
              v-if="scope.row.pic"
            >
              <mu-icon left value="image"></mu-icon>
              查看
            </mu-button>
            <span v-else>无图片</span>
          </td>
          <td>{{ scope.row.remark }}</td>
          <td>
            <mu-button color="info" @click="edit(scope.row)">
              <mu-icon left value="edit" :size="20"></mu-icon>
              编辑
            </mu-button>
            <mu-button color="secondary" @click="deleteOne(scope.row)">
              <mu-icon left value="delete" :size="20"></mu-icon>
              删除
            </mu-button>
          </td>
        </template>
      </mu-data-table>
    </mu-paper>
    <div class="page">
      <div class="info">共{{ total }}条记录</div>
      <mu-pagination
        raised
        :total="total"
        :current.sync="form.page"
        :page-size="15"
        @change="getAll"
      ></mu-pagination>
    </div>
    <Create :open.sync="addOpen" @finish="getAll()"></Create>
    <Update :open.sync="editOpen" :form="editForm" @finish="getAll()"></Update>
    <ImageView :open.sync="imageOpen" :imageList="imageList"></ImageView>
  </div>
</template>

<script>
import Create from './create'
import Update from './update'
import backend from 'utils/backend'
import ImageView from '@/components/imageView'
import api from '@/api'
import moment from 'moment'
export default {
  components: { Create, Update, ImageView },
  data() {
    return {
      sum: 0,
      moment,
      loading: false,
      addOpen: false,
      editOpen: false,
      editForm: {},
      imageOpen: false,
      imageList: [],
      form: {
        keyword: '',
        page: 1,
        relations: ['invoice.customer'],
        startTime: moment().startOf('month').toDate(),
        endTime: moment().endOf('month').toDate()
      },
      total: 1,
      columns: [
        {
          title: '客户信息',
          name: 'customer',
          align: 'center'
        },
        {
          title: '开票信息',
          name: 'buyer',
          align: 'center'
        },
        {
          title: '金额信息',
          name: 'amount',
          align: 'center'
        },
        {
          title: '发票信息',
          name: 'totalAmount',
          align: 'center'
        },
        {
          title: '图片',
          name: 'pic',
          align: 'center'
        },
        {
          title: '备注',
          name: 'remark',
          align: 'center'
        },
        {
          title: '操作',
          align: 'center',
          width: 300
        }
      ],
      list: []
    }
  },
  methods: {
    edit(item) {
      this.editForm = item
      this.editOpen = true
    },
    deleteOne(item) {
      this.$confirm('确定要删除？', '提示', {
        type: 'warning'
      }).then(({ result }) => {
        if (result) {
          backend(api.invoice.delete, { id: item.id }).then((result) => {
            if (result.statusCode === 200) {
              this.$toast.success('删除成功')
              this.getAll()
            }
          })
        }
      })
    },
    getAll() {
      this.loading = true
      backend(api.invoice.getAll, this.form).then((result) => {
        if (result.statusCode === 200) {
          this.loading = false
          this.list = result.data.rows
          this.total = result.data.count
          this.sum = result.data.sum
        }
      })
    },
    viewImages(pic) {
      this.imageList = [pic]
      this.imageOpen = true
    }
  },
  mounted() {
    this.getAll()
  }
}
</script>

<style lang="less" scoped>
.invoice-index {
  position: relative;
  .analysis {
    position: absolute;
    right: 20px;
    top: 40px;
  }
  .title {
    font-size: 20px;
    margin-bottom: 10px;
    line-height: 36px;
    .add-btn {
      margin-left: 20px;
    }
  }
  .table {
    td {
      text-align: center;
    }
  }
  .page {
    position: absolute;
    right: 30px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    .info {
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/invoice/index.vue